import { ISagaModule } from 'redux-dynamic-modules-saga';
import reducer from './reducer';
import saga from './saga';
import { reduxInitialized } from './actions';

export function getDiscordModule(): ISagaModule<any> {
  return {
    id: 'discordModule',
    reducerMap: reducer,
    initialActions: [reduxInitialized()],
    sagas: [saga],
  };
}
